/**
 * Opens the free intro form on a therapist profile from anywhere on the page
 * (hero, "Ce te aduce aici?", phone bar). TherapistBookingCtas owns the modals
 * and listens for this. An event rather than `?action=demo`: a link to the URL
 * the page is already on does nothing the second time it is tapped.
 */
export const OPEN_DISCOVERY_EVENT = "mindtale:open-discovery";

export function openDiscovery(source: string) {
  window.dispatchEvent(new CustomEvent(OPEN_DISCOVERY_EVENT, { detail: { source } }));
}
